import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import './chart.css';

function ChartLine({
  data,
  categoryKey,
  valueKey,
  percentageKey,
  chartType = "line",
  titleX,
  titleY,
  seriesName = "Data",
  showPercentage = true,
}) {
  const categories = useMemo(
    () => data?.map((item) => item[categoryKey]) ?? [],
    [data, categoryKey]
  );

  const series = useMemo(
    () => [{
      name: seriesName,
      data: showPercentage
        ? (data ?? []).map((item) => item[percentageKey])
        : (data ?? []).map((item) => item[valueKey]),
    }],
    [seriesName, showPercentage, data, percentageKey, valueKey]
  );

  const options = useMemo(
    () => ({
      chart: { type: chartType },
      dataLabels: {
        enabled: true,
        formatter: (val) => showPercentage ? `${val.toFixed(0)}%` : val,
      },
      xaxis: {
        categories,
        title: { text: titleX, style: { color: "var(--text-50)" } },
        labels: { style: { colors: "var(--text-50)" } },
      },
      yaxis: {
        title: { text: titleY, style: { color: "var(--text-50)" } },
        labels: {
          style: { colors: "var(--text-50)" },
          formatter: (val) => showPercentage ? `${val.toFixed(0)}%` : val,
        },
      },
      tooltip: {
        y: { formatter: (val) => showPercentage ? `${val.toFixed(2)}%` : val },
      },
      legend: { labels: { colors: "var(--text-50)" } },
    }),
    [chartType, showPercentage, categories, titleX, titleY]
  );

  return (
    <Chart options={options} series={series} type={chartType} height="100%" width="100%" />
  );
}

export default memo(ChartLine);
